module.exports = __webpack_public_path__ + "media/components/assets/icons/board/announce-befa548fa6d803f721c2a01b3cceefd2.svg";